// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2lCxD","legacyBtn":"MutateMid_legacyBtn__1XwwM"};